// @ts-nocheck
import * as Types from '../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import { ConfiguratorContext_ProgramDataFragmentDoc } from '../../../fragments/circularFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type LotStepQueryVariables = Types.Exact<{
  communityId: Types.Scalars['ID'];
}>;


export type LotStepQuery = { __typename?: 'Query', community: { __typename?: 'Community', id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, showInCheckout: boolean, displayName: string, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined } }> }, structures: { __typename?: 'StructuresPageResult', entities: Array<{ __typename?: 'Structure', id: string, name: string, latitude?: number | null | undefined, longitude?: number | null | undefined, isConstructionComplete: boolean, hasStartedConstruction: boolean, parent: { __typename?: 'Lot', id: string, buildablePlans: Array<{ __typename?: 'ProductOffering', id: string, displayName: string }> }, lotSalesStatus?: { __typename?: 'LotSalesStatusDetail', code: Types.LotSalesStatus } | null | undefined, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, includedPriceInCents?: number | null | undefined, programData?: { __typename?: 'ProgramData', id: string, garageAttached?: number | null | undefined, garagePort?: number | null | undefined, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined } | null | undefined, readyPlan?: { __typename?: 'ReadyPlan', id: string, name: string } | { __typename?: 'PlanPackage', id: string, name: string } | { __typename?: 'DesignPackage', id: string, name: string } | { __typename?: 'ProductOffering', id: string, name: string } | null | undefined } | null | undefined }> } };

export type LotStep_CreateCheckoutConfigMutationVariables = Types.Exact<{
  structureId: Types.Scalars['ID'];
  homeownerId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type LotStep_CreateCheckoutConfigMutation = { __typename?: 'Mutation', saveCheckoutConfig: { __typename?: 'SaveCheckoutConfigResult', checkoutConfig: { __typename?: 'CheckoutConfig', id: string } } };

export type LotStep_StructureFragment = { __typename?: 'Structure', id: string, name: string, latitude?: number | null | undefined, longitude?: number | null | undefined, isConstructionComplete: boolean, hasStartedConstruction: boolean, parent: { __typename?: 'Lot', id: string, buildablePlans: Array<{ __typename?: 'ProductOffering', id: string, displayName: string }> }, lotSalesStatus?: { __typename?: 'LotSalesStatusDetail', code: Types.LotSalesStatus } | null | undefined, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, includedPriceInCents?: number | null | undefined, programData?: { __typename?: 'ProgramData', id: string, garageAttached?: number | null | undefined, garagePort?: number | null | undefined, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined } | null | undefined, readyPlan?: { __typename?: 'ReadyPlan', id: string, name: string } | { __typename?: 'PlanPackage', id: string, name: string } | { __typename?: 'DesignPackage', id: string, name: string } | { __typename?: 'ProductOffering', id: string, name: string } | null | undefined } | null | undefined };

export type LotStep_BuildablePlansFragment = { __typename?: 'ProductOffering', id: string, displayName: string };

export type LotStep_CommunityFragment = { __typename?: 'Community', id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, showInCheckout: boolean, displayName: string, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined } }> };

export type LotStep_Community_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, showInCheckout: boolean, displayName: string, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined } };

export const LotStep_BuildablePlansFragmentDoc = gql`
    fragment LotStep_BuildablePlans on ProductOffering {
  id
  displayName
}
    `;
export const LotStep_StructureFragmentDoc = gql`
    fragment LotStep_Structure on Structure {
  id
  name
  latitude
  longitude
  isConstructionComplete
  hasStartedConstruction
  parent {
    id
    buildablePlans {
      ...LotStep_BuildablePlans
    }
  }
  lotSalesStatus {
    code
  }
  readyPlanConfig {
    id
    programData {
      ...ConfiguratorContext_ProgramData
    }
    includedPriceInCents
    readyPlan {
      id
      name
    }
  }
}
    ${LotStep_BuildablePlansFragmentDoc}
${ConfiguratorContext_ProgramDataFragmentDoc}`;
export const LotStep_Community_ProductOfferingFragmentDoc = gql`
    fragment LotStep_Community_ProductOffering on ProductOffering {
  id
  showInCheckout
  displayName
  minProgramData {
    id
    bedrooms
    fullBaths
    halfBaths
    sellableSqft
  }
  maxProgramData {
    id
    bedrooms
    fullBaths
    halfBaths
    sellableSqft
  }
}
    `;
export const LotStep_CommunityFragmentDoc = gql`
    fragment LotStep_Community on Community {
  id
  name
  productOfferings {
    ...LotStep_Community_ProductOffering
  }
}
    ${LotStep_Community_ProductOfferingFragmentDoc}`;
export const LotStepDocument = gql`
    query LotStep($communityId: ID!) {
  community(id: $communityId) {
    ...LotStep_Community
  }
  structures(filter: {parentRecursive: [$communityId], showInCheckout: true}) {
    entities {
      ...LotStep_Structure
    }
  }
}
    ${LotStep_CommunityFragmentDoc}
${LotStep_StructureFragmentDoc}`;

/**
 * __useLotStepQuery__
 *
 * To run a query within a React component, call `useLotStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotStepQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useLotStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LotStepQuery, LotStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LotStepQuery, LotStepQueryVariables>(LotStepDocument, options);
      }
export function useLotStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LotStepQuery, LotStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LotStepQuery, LotStepQueryVariables>(LotStepDocument, options);
        }
export type LotStepQueryHookResult = ReturnType<typeof useLotStepQuery>;
export type LotStepLazyQueryHookResult = ReturnType<typeof useLotStepLazyQuery>;
export type LotStepQueryResult = Apollo.QueryResult<LotStepQuery, LotStepQueryVariables>;
export const LotStep_CreateCheckoutConfigDocument = gql`
    mutation LotStep_CreateCheckoutConfig($structureId: ID!, $homeownerId: ID) {
  saveCheckoutConfig(
    input: {structureId: $structureId, homeownerId: $homeownerId}
  ) {
    checkoutConfig {
      id
    }
  }
}
    `;
export type LotStep_CreateCheckoutConfigMutationFn = Apollo.MutationFunction<LotStep_CreateCheckoutConfigMutation, LotStep_CreateCheckoutConfigMutationVariables>;

/**
 * __useLotStep_CreateCheckoutConfigMutation__
 *
 * To run a mutation, you first call `useLotStep_CreateCheckoutConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLotStep_CreateCheckoutConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lotStepCreateCheckoutConfigMutation, { data, loading, error }] = useLotStep_CreateCheckoutConfigMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      homeownerId: // value for 'homeownerId'
 *   },
 * });
 */
export function useLotStep_CreateCheckoutConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LotStep_CreateCheckoutConfigMutation, LotStep_CreateCheckoutConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LotStep_CreateCheckoutConfigMutation, LotStep_CreateCheckoutConfigMutationVariables>(LotStep_CreateCheckoutConfigDocument, options);
      }
export type LotStep_CreateCheckoutConfigMutationHookResult = ReturnType<typeof useLotStep_CreateCheckoutConfigMutation>;
export type LotStep_CreateCheckoutConfigMutationResult = Apollo.MutationResult<LotStep_CreateCheckoutConfigMutation>;
export type LotStep_CreateCheckoutConfigMutationOptions = Apollo.BaseMutationOptions<LotStep_CreateCheckoutConfigMutation, LotStep_CreateCheckoutConfigMutationVariables>;